import { Box } from '@mui/material';
import type { FC } from 'react';
import { Suspense, useCallback } from 'react';
import { usePagination } from 'hooks';
import CreativesViewSkeleton from '../../creatives/components/CreativesViewSkeleton';
import FacebookAdsCreativeView from './FacebookAdsCreativeView';
import GoogleAdsCreativeView from './GoogleAdsCreativeView';
import FbAdsFilterBar from './FbAdsFilterBar';
import useFacebookAdsLibraryParams from '../hooks/useFacebookAdsLibraryParams';
import useAdsLibraryFilterTracking from '../hooks/useAdsLibraryFilterTracking';

const CreativesFbAds: FC = () => {
  const {
    ordering,
    actualBranches,
    actualCompany,
    actualAdTypes,
    actualPageName,
    actualDomains,
    actualFlows,
    actualAdvertiserIds,
    startDate,
    endDate,
    isRunning,
    newOnly,
    includeWelltech,
    lastShownRecently,
    network,
    region,
    resetParams,
    branches,
    company,
    pageName,
    domains,
    flows,
    adTypes,
    languages,
    advertiserIds,
    googleAdTypes,
  } = useFacebookAdsLibraryParams();

  const isGoogleNetwork = network === 'google';

  const { resetPagination } = usePagination([
    ordering,
    actualBranches,
    actualCompany,
    actualAdTypes,
    actualPageName,
    actualDomains,
    actualFlows,
    actualAdvertiserIds,
    startDate,
    endDate,
    isRunning,
    newOnly,
    includeWelltech,
    lastShownRecently,
    network,
    region,
  ]);

  const handleReset = useCallback(() => {
    resetPagination();
    resetParams();
  }, [resetPagination, resetParams]);

  useAdsLibraryFilterTracking({
    network,
    region,
    ordering,
    branches,
    company,
    pageName,
    domains,
    flows,
    adTypes,
    languages,
    advertiserIds,
    googleAdTypes,
    startDate,
    endDate,
    isRunning,
    newOnly,
    includeWelltech,
    lastShownRecently,
  });

  return (
    <>
      <FbAdsFilterBar onReset={handleReset} />
      <Box sx={{ px: 3 }}>
        <Suspense fallback={<CreativesViewSkeleton />}>
          {isGoogleNetwork ? (
            <GoogleAdsCreativeView resetFilters={handleReset} />
          ) : (
            <FacebookAdsCreativeView resetFilters={handleReset} />
          )}
        </Suspense>
      </Box>
    </>
  );
};

export default CreativesFbAds;
